import { z } from 'zod';

// Add to this list as new lenders are added //TODO: refactor to follow zod schema paradigm
const LenderIds = ['FRF', 'IRONHORSE', 'OCTANE', 'DEALER-DIRECT'];
const LenderIdSchema = z.enum(LenderIds);

export { LenderIdSchema, LenderIds };
//# sourceMappingURL=general.js.map
